export default class TextHelper {
  public static readonly romanNumerals = [
    'I',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX',
    'X'
  ];

  static truncateString(t: string, n: number) {
    return t.substring(0, n - 1) + (this.length > n ? '&hellip;' : '');
  }

  public static readonly prepositions = [
    'a',
    'al',
    'de',
    'del',
    'el',
    'la',
    'y',
    'o',
    'los',
    'que',
    'las',
    'en',
    'con',
    'por',
    'para',
    'e'
  ];

  public static readonly exceptions = ['ti', 'tic', 'preg', 'cgt'];

  static evalText(t: string) {
    if (TextHelper.romanNumerals.includes(t.toUpperCase()))
      return t.toUpperCase();
    if (TextHelper.prepositions.includes(t.toLowerCase()))
      return t.toLowerCase();
    return `${t.toUpperCase().substring(0, 1)}${t.toLowerCase().slice(1)}`;
  }

  static evalText2(t: string) {
    if (TextHelper.romanNumerals.includes(t.toUpperCase()))
      return t.toUpperCase();
    if (TextHelper.prepositions.includes(t.toLowerCase()))
      return t.toLowerCase();
    return t;
  }

  public static capitalize(
    text: string,
    ignoreLine = false,
    onlyFirst = false
  ) {
    if (!text) return '';
    const arrText = text?.toLowerCase().split(' ');

    if (onlyFirst) {
      return text
        .toLowerCase()
        .split(' ')
        .map((t, i) =>
          i === 0
            ? `${t.toUpperCase().substring(0, 1)}${t.toLowerCase().slice(1)}`
            : this.evalText2(t)
        )
        .join(' ');
    }

    let s: any = [];

    if (arrText?.length) {
      s = arrText.map((t: string) => {
        if (TextHelper.exceptions.includes(t)) {
          return t.toUpperCase();
        }

        let capitalizeText = '';
        capitalizeText = this.evalText(t)
          .split(ignoreLine ? ' ' : '-')
          .reduce((a, b) => `${this.evalText(a)} ${this.evalText(b)}`);

        return capitalizeText;
      });
    }

    return s.join(' ');
  }

  public static fixRomans(text: string) {
    const arrText = text?.split(/(\b|[()])/);
    let s: any = [];
    if (arrText?.length) {
      s = arrText.map((t) => {
        const fixText = TextHelper.romanNumerals.includes(
          t.toUpperCase().replace(/[()]/g, '')
        )
          ? t.toUpperCase()
          : t;
        return fixText;
      });
    }
    return s.join('');
  }

  public static elipsis(text: string, limit = 22) {
    let blocktext = text ?? '';
    if (blocktext.length > limit && limit) {
      if (limit === 1) {
        blocktext = `${text.charAt(0)}`;
      } else {
        blocktext = `${this.truncateString(text, limit).substring(
          0,
          blocktext.length - 2
        )}...`;
      }
    }
    return blocktext;
  }
}
